import { defineMessages } from 'react-intl';

export default defineMessages({
  edit: {
    id: 'StepCheckout.step.edit',
    description: 'Edit message',
    defaultMessage: 'Edit',
  },
});
